import { Page } from './domain/page';
import { CompanyPage } from './pages/CompanyPage';
import { EmailPage } from './pages/EmailPage';
import { GoogleSheetsPage } from './pages/GoogleSheetsPage';
import { HomePage } from './pages/HomePage';
import { MeetingPage } from './pages/MeetingPage';
import { SearchPage } from './pages/SearchPage';
import { SettingsPage } from './pages/SettingsPage';

export const routingConfig = [
  { page: Page.Company, component: CompanyPage },
  { page: Page.Contact, component: CompanyPage },
  { page: Page.Search, component: SearchPage },
  { page: Page.Settings, component: SettingsPage },
  { page: Page.Home, component: HomePage },
  { page: Page.Meeting, component: MeetingPage },
  { page: Page.Email, component: EmailPage },
  { page: Page.GoogleSheets, component: GoogleSheetsPage },
];
